import React from 'react';
import { History, X } from 'lucide-react';

// Componente para formatear la fecha y hora
const formatDate = (timestamp) => {
    if (!timestamp) return 'Fecha no disponible';
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    if (isNaN(date.getTime())) return 'Fecha inválida';
    return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
};

const LogModal = ({ isOpen, history, onClose }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-70 z-[61] flex justify-center items-center p-4">
            <div className="bg-white rounded-lg shadow-2xl w-full max-w-2xl max-h-[80vh] flex flex-col">
                <header className="p-4 border-b flex justify-between items-center bg-gray-50 rounded-t-lg">
                    <h2 className="text-lg font-bold text-gray-800 flex items-center gap-2">
                        <History size={20}/> Historial de la Plancha
                    </h2>
                    <button onClick={onClose} className="text-gray-500 hover:text-gray-800">
                        <X size={24} />
                    </button>
                </header>
                <div className="p-6 space-y-3 overflow-y-auto">
                    {!history || history.length === 0 ? (
                        <p className="text-center text-gray-500 py-8">No hay historial para esta plancha.</p>
                    ) : (
                        [...history].reverse().map((log, index) => (
                            <div key={index} className="p-3 bg-gray-50 rounded-md border border-gray-200 text-sm">
                                <div className="flex justify-between items-start">
                                    <p className="font-bold text-gray-800">{log.action}</p>
                                    <span className="text-xs text-gray-500 whitespace-nowrap">{formatDate(log.timestamp)}</span>
                                </div>
                                {log.details && <p className="text-gray-600 mt-1 pl-1 border-l-2 border-gray-300">{log.details}</p>}
                                {log.user && <p className="text-xs text-gray-500 mt-2 text-right">por: {log.user}</p>}
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

export default LogModal;
